<template>
    <Card>

        <template slot="title">
            Resource Type Summary
        </template>

        <template>
            <table class="table">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Expected</th>
                        <th>Actual</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(type, index) in resourceTypeSummary" :key="index">
                        <td>{{ type.name }}</td>
                        <td>{{ formatCurrency(type.expected) }}</td>
                        <td>{{ formatCurrency(type.actual) }}</td>
                    </tr>
                </tbody>
            </table>
        </template>

    </Card>
</template>

<script>
import Card from '@/components/Card';
import * as helpers from '@/utils/helpers';

export default {

    components: {
        Card,
    },

    computed: {
        resourceTypeSummary() {
            return this.$store.getters['costable/resourceTypeSummary'];
        },
    },

    methods: {
        ...helpers,
    },

};
</script>
